import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Language } from '@boels/models';

@Component({
  selector: 'boels-language-selector-modal-item-link',
  templateUrl: './language-selector-modal-item-link.component.html',
  styleUrls: ['./language-selector-modal-item-link.component.scss'],
  imports: [CommonModule],
})
export class LanguageSelectorModalItemLinkComponent implements OnChanges {
  @Input() language: Language;
  @Input() baseSiteCode: string;

  @Output() languageEventEmitter: EventEmitter<Language> = new EventEmitter();

  languageIsoCode: string;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['language'] || changes['baseSiteCode']) {
      this.languageIsoCode = this.getGenericLanguage();
    }
  }

  emitLanguage(): void {
    this.languageEventEmitter.emit(this.language);
  }

  getGenericLanguage(): string {
    return this.language?.isocode?.split('_')[0] as string;
  }
}
